enum NavigationColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export default NavigationColor;
